$(document).ready(function () {

    function actOnclickedString(recString) {
        console.log("Selected gateway:", recString);

        // Hide all gateway sections
        $("div[id^='gatewayName']").hide();

        // Show only the selected one
        $("#gatewayName" + recString).show();
    }

    // Radio buttons → use change (correct event)
    $("input[name='gateway']").on("change", function () {
        actOnclickedString(this.value);
    });

    // Initial load (checked radio)
    actOnclickedString($("input[name='gateway']:checked").val());
});
